import './App.css';
import ChartistGraph from 'react-chartist';
import {useEffect, useState} from "react";

const RISK_DATA_URL = "https://3yac06pcn2.execute-api.eu-central-1.amazonaws.com/dev/iframe/risk/zpg";

const initialData = {
    labels: ['Niskie', 'Średnie', 'Znaczne', 'Wysokie'],
    series: [12, 5, 5, 0]
};

// doc: https://gionkunz.github.io/chartist-js/api-documentation.html#chartistpie-function-pie
const options = {
    width: "100%",
    height: 400,
    chartPadding: 5,
    startAngle: 0,
    // An optional total you can specify. By specifying a total value, the sum of the values in the series must be this total in order to draw a full pie. You can use this parameter to draw only parts of a pie or gauge charts.
    total: 24,
    // If a label should be shown or not
    showLabel: true,
    ignoreEmptyValues: true
};

const type = 'Pie'

function App() {
    const [data, setData] = useState(initialData);

    useEffect(() => {
        fetch(RISK_DATA_URL).then(response => {
            response.json().then(result => setData(result));
        }).catch(error => console.error(error));
    }, []);

    return (
        <div className="App">
            {/* LEFT SIDE - PIE CHART */}
            <div className="chart-left">
                <ChartistGraph data={data} options={options} type={type}/>
            </div>

            {/* RIGHT SIDE TEXT AND LEGEND */}
            <div className="desc-right">
                {document.documentElement.lang === "pl-PL" ?
                    <>
                        <p>
                            Występujące warunki meteorologiczne mają&nbsp;duży wpływ na&nbsp;jakość powietrza
                            w&nbsp;danym&nbsp;rejonie.
                            Mogą sprzyjać akumulacji drobnych pyłów w&nbsp;najniższej warstwie atmosfery,
                            w&nbsp;której&nbsp;na&nbsp;co&nbsp;dzień funkcjonujemy, np.&nbsp;w&nbsp;wypadku występowania
                            słabego wiatru czy&nbsp;inwersji temperatury. Z&nbsp;kolei silny wiatr, czy&nbsp;opady
                            “oczyszczają” atmosferę.
                        </p>
                        <p>
                            <b>Na wykresie kołowym można&nbsp;przeanalizować jakie&nbsp;danego&nbsp;dnia&nbsp;(24h)
                                jest&nbsp;ryzyko akumulacji&nbsp;pyłów
                                PM10&nbsp;i&nbsp;PM2.5 w&nbsp;najniższej warstwie atmosfery:
                            </b>
                        </p>
                    </> :
                    <>
                        <p>
                            Weather conditions have a&nbsp;strong influence on&nbsp;the&nbsp;air quality within a&nbsp;given area.
                            Sometimes, the&nbsp;specific meteorological situation may favor the&nbsp;accumulation of&nbsp;small particles in&nbsp;the&nbsp;lowest layer of&nbsp;the&nbsp;atmosphere
                            - the one we&nbsp;live&nbsp;in. Such situations often happen when the&nbsp;wind is&nbsp;very weak or&nbsp;temperature inversion is&nbsp;generated low in&nbsp;the&nbsp;atmosphere.
                            Whereas strong wind and&nbsp;precipitation “clear&nbsp;the&nbsp;atmosphere”.
                        </p>
                        <p>
                            <b>On the chart you can see what is&nbsp;the risk of&nbsp;particulate matter (PM10,&nbsp;PM2.5)
                                accumulation in&nbsp;the&nbsp;lowest layer of&nbsp;the atmosphere during a&nbsp;given day&nbsp;(24h):
                            </b>
                        </p>
                    </>
                }
                <div className="legend-container">
                    <div className="legend-item">
                        <div className="legend-btn color1"/>
                        {document.documentElement.lang === "pl-PL" ? <b>Niskie</b> : <b>Low</b>}
                    </div>
                    <div className="legend-item">
                        <div className="legend-btn color2"/>
                        {document.documentElement.lang === "pl-PL" ? <b>Średnie</b> : <b>Moderate</b>}
                    </div>
                    <div className="legend-item">
                        <div className="legend-btn color3"/>
                        {document.documentElement.lang === "pl-PL" ? <b>Znaczne</b> : <b>Severe</b>}
                    </div>
                    <div className="legend-item">
                        <div className="legend-btn color4"/>
                        {document.documentElement.lang === "pl-PL" ? <b>Wysokie</b> : <b>High</b>}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default App;
